module.exports = ".dialog-wrapper div.img {\n  text-align: center; }\n  .dialog-wrapper div.img img {\n    border: 1px solid silver;\n    padding: 1em; }\n  .dialog-wrapper div.img img.new {\n    border-color: #f44336; }\n\n.dialog-wrapper div.receipt-item {\n  border-bottom: 1px solid #e0e0e0;\n  padding: 0.5em; }\n\n.dialog-wrapper div.receipt-note {\n  font-style: italic;\n  padding-bottom: 1em; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/product-dialog/product-dialog.component.scss
// module id = 1492
// module chunks = 0